import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { LucideModule } from '../../../../shared/modules/lucide.module';
import { ConfirmacaoSaidaService } from '../../../../shared/utils/confirmacao-saida.service';

@Component({
  selector: 'app-todos-servicos-usuario-logado',
  templateUrl: './todos-servicos-usuario-logado.component.html',
  styleUrls: ['./todos-servicos-usuario-logado.component.css'],
  imports: [RouterLink, LucideModule],
})
export class TodosServicosUsuarioLogadoComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly confirmacaoSaida = inject(ConfirmacaoSaidaService);

  readonly linkMinhaArea = input('/area-cidadao');

  readonly mostrarAcessoArea = input(true);

  private readonly usuario = toSignal(this.authService.currentUser, {
    initialValue: this.authService.currentUserValue,
  });

  readonly logado = computed(() => !!this.usuario() && !this.authService.isTokenExpired());

  readonly identificacao = computed(() => {
    const usuario = this.usuario();
    return usuario?.nome?.trim() || usuario?.email?.trim() || '';
  });

  async sair(): Promise<void> {
    if (!(await this.confirmacaoSaida.confirmar())) {
      return;
    }

    this.authService.logout();
    this.router.navigate(['/homepage']);
  }
}
